import { useAuth } from '@/stores/AuthContext';
import { Avatar, Button, Dropdown } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMenuItems } from '../hooks/useMenuItems';

export const UserAvatar = observer(() => {
  const { user } = useAuth();
  const { items } = useMenuItems();

  if (!user) return null;

  const avatar_letter = (user.profile?.name ?? user.email)
    .split(' ')
    .map((name: string) => name[0])
    .join('')
    .toUpperCase();

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Button type="text" className="flex items-center gap-2">
        <Avatar className="h-8 w-8">{avatar_letter}</Avatar>
        <span>{user.profile?.name}</span>
      </Button>
    </Dropdown>
  );
});
